/* src/app/core/pages/login-load/login-load.component.scss */
.main-container {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.main-container .body-container {
  animation: forwards fadeIn 0.5s 0s;
  transform: scale(1.3);
  opacity: 0;
  width: min-content;
}
.main-container .bino {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}
.main-container .bino img {
  width: 122vh;
  height: 74vh;
  margin: 0;
  padding: 0;
  margin-bottom: -2px;
}
.main-container-home {
  position: fixed;
  top: 0;
  left: 0;
}
.main-container-home-loading {
  animation: forwards display 0s 1.2s;
}
.main-container-home-loading .bino img {
  animation: forwards zoomIn;
  animation-delay: 0s;
  animation-duration: 1.2s;
}
@keyframes display {
  0% {
    display: none;
  }
  100% {
    display: none;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(1.3);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes zoomIn {
  0% {
    width: 122vh;
    height: 74vh;
    opacity: 1;
  }
  100% {
    width: 204vh;
    height: 119vh;
    transform: scale(18);
    margin-left: 283%;
    opacity: 0;
    display: none;
  }
}
/*# sourceMappingURL=login-load.component.css.map */
